import { createReducer, on } from '@ngrx/store';
import { initialTeamsState, ITeamsState } from './teams.state';
import {
  TeamsError, TeamsLoaded, TeamAddSuccess, TeamUpdateSuccess, TeamDeleteSuccess

} from './teams.actions';

export const initialState: ITeamsState = {
  teams: []
};

const setTeams = (state: ITeamsState, { teams }: { teams: [] }) => ({
  ...state,
  teams: [...state.teams, ...teams]
});

const addTeam = (state: ITeamsState, { team }) => {
 
  return {
    ...state,
    teams: [...state.teams, team]
  };

};

const updateTeam = (state: ITeamsState, { team }) => {
  return {
  ...state,
  teams: state.teams.map(t => (t.id === team.id ? team : t))
}};

const deleteTeam = (state: ITeamsState, { teamId }) => ({
  ...state,
  teams: state.teams.filter(team => team.id !== teamId)
});

const _teamsReducer = createReducer<ITeamsState>(
  initialTeamsState,
  on(TeamsLoaded, setTeams),
  on(TeamAddSuccess, addTeam),
  on(TeamUpdateSuccess, updateTeam),
  on(TeamDeleteSuccess, deleteTeam)
);

export function teamsReducer(state: ITeamsState, action): ITeamsState {
  return _teamsReducer(state, action);
}
